import AdminRegistration from '../../Registration/Admin/i18n.cs';
import Announcements from '../../Announcements/i18n.cs';
import Building from '../../Building/i18n.cs';
import Deadlines from '../../Deadlines/i18n.cs';
import Card from '../components/Cards/i18n.cs';
import Date from '../utils/Date/i18n.cs';
import DateField from '../components/Form/DateField/i18n.cs';
import Editor from '../components/Editor/i18n.cs';
import Feed from '../../Feed/i18n.cs';
import FileField from '../components/Form/FileField/i18n.cs';
import Files from '../../FileStorage/i18n.cs';
import FormValidation from '../utils/FormValidation/i18n.cs';
import Header from '../components/Header/i18n.cs';
import Invitation from '../../Registration/Invitation/i18n.cs';
import Welcome from '../../Welcome/i18n.cs';
import Issues from '../../Issues/i18n.cs';
import Login from '../../Login/i18n.cs';
import MobileAppBanner from '../components/MobileAppBanner/i18n.cs';
import NotificationUnsubscribe from '../../NotificationUnsubscribe/i18n.cs';
import OtherServices from '../../OtherServices/i18n.cs';
import PasswordField from '../components/Form/PasswordField/i18n.cs';
import PasswordReset from '../../PasswordReset/i18n.cs';
import Playground from '../../Playground/i18n.cs';
import Poll from '../../Poll/i18n.cs';
import Profile from '../../Profile/i18n.cs';
import ReadReceipt from '../components/ReadReceipt/i18n.cs';
import Registration from '../../Registration/i18n.cs';
import Registry from '../../Registry/i18n.cs';
import SelectField from '../components/Form/SelectField/i18n.cs';
import Sidebar from '../components/Sidebar/i18n.cs';
import Subscription from '../../Subscription/i18n.cs';
import Units from '../../Units/i18n.cs';

const App = {
  title: 'eVlastníci',
  emptyState: 'Nic jsme tu nenalezli',
  demoAvailability: 'Tato funkce není dostupná v demo verzi aplikace.',
  demoRegistration: {
    heading: 'Registrace není v demo verzi dostupná',
    text: 'V demo verzi si můžete vyzkoušet připravený ukázkový dům. Svůj dům zaregistrujete zdarma v plné verzi aplikace.',
    toApp: 'Registrovat dům v plné verzi',
    back: 'Zpět do dema',
  },
  afterGracePeriod: 'Tato funkce je dostupná pouze u placeného plánu.',
  BuildingAccessDenied: {
    heading: 'K tomuto domu nemáte přístup',
    text: 'Odkaz vede do domu, ke kterému přihlášený účet {{email}} nemá přístup. Zkontrolujte, zda jste přihlášeni správným účtem — e-mail s odkazem jsme poslali na adresu, pod kterou jste v domě evidováni.',
    switchAccount: 'Přihlásit se jiným účtem',
    continue: 'Pokračovat do aplikace',
  },
};

const Enums = {
  UnitUseType: {
    flat: 'Byt',
    studio: 'Ateliér',
    garage: 'Garáž',
    workshop: 'Provozovna/dílna',
    other: 'Jiný nebytový prostor',
    unit_under_construction: 'Rozestavěná jednotka',
    group_of_flats: 'Skupina bytů',
    group_of_non_residential: 'Skupina nebytových prostorů',
    group_of_flats_and_non_residential: 'Skupina bytů a nebytových prostorů',
  },
  UnitType: {
    flat: 'Byt',
    flat_under_construction: 'Rozestavěný byt nebo nebytový prostor',
    unit_by_law_ownership: 'Jednotka vymezená podle zákona o vlastnictví bytů',
    unit_by_civil_code: 'Jednotka vymezená podle občanského zákoníku',
  },
  ContactType: {
    committe: 'Výbor',
    controlAuthority: 'Kontrolní orgán',
    externalContact: 'Ostatní kontakty',
  },
  OwnerType: {
    missingAll: 'Chybí kontakty',
    missingPhone: 'Chybí telefon',
    missingEmail: 'Chybí email',
    missingNone: 'Vyplněné údaje',
  },
  ContactPositionsTypes: {
    chairman: 'Předseda výboru',
    deputychairman: 'Místopředseda výboru',
    member: 'Člen výboru',
  },
  RuianHeating: {
    central_building: 'Ústřední domovní (kotel v domě)',
    central_remote: 'Dálkové (CZT)',
    local: 'Lokální',
    other: 'Jiné (i bez topení)',
    central_building_natural_gas: 'Ústřední domovní – zemní plyn',
    central_building_coal: 'Ústřední domovní – uhlí',
    central_building_wood_biomass: 'Ústřední domovní – dřevo a biomasa',
    central_building_wood_pellets: 'Ústřední domovní – dřevěné pelety',
    central_building_electricity: 'Ústřední domovní – elektřina',
    central_building_heat_pump: 'Ústřední domovní – tepelné čerpadlo',
    central_building_solar: 'Ústřední domovní – solární/fotovoltaické systémy',
    central_building_liquid_fuels: 'Ústřední domovní – kapalná paliva',
    central_building_other_fuel: 'Ústřední domovní – jiné palivo',
    central_remote_natural_gas: 'Dálkové (CZT) – zemní plyn',
    central_remote_coal: 'Dálkové (CZT) – uhlí',
    central_remote_wood_biomass: 'Dálkové (CZT) – dřevo a biomasa',
    central_remote_wood_pellets: 'Dálkové (CZT) – dřevěné pelety',
    central_remote_electricity: 'Dálkové (CZT) – elektřina',
    central_remote_heat_pump: 'Dálkové (CZT) – tepelné čerpadlo',
    central_remote_solar: 'Dálkové (CZT) – solární/fotovoltaické systémy',
    central_remote_liquid_fuels: 'Dálkové (CZT) – kapalná paliva',
    central_remote_other_fuel: 'Dálkové (CZT) – jiné palivo',
    local_natural_gas: 'Lokální – zemní plyn',
    local_coal: 'Lokální – uhlí',
    local_wood_biomass: 'Lokální – dřevo a biomasa',
    local_wood_pellets: 'Lokální – dřevěné pelety',
    local_electricity: 'Lokální – elektřina',
    local_heat_pump: 'Lokální – tepelné čerpadlo',
    local_solar: 'Lokální – solární/fotovoltaické systémy',
    local_liquid_fuels: 'Lokální – kapalná paliva',
    local_other_fuel: 'Lokální – jiné palivo',
  },
  RuianGasConnection: {
    public_network: 'Z veřejné sítě',
    storage_tank: 'Z domovního zásobníku',
    no_gas: 'Bez plynu',
    storage_tank_lpg: 'Z domovního zásobníku – LPG',
    storage_tank_cng: 'Z domovního zásobníku – CNG',
    storage_tank_biogas: 'Z domovního zásobníku – bioplyn',
    storage_tank_mine_gas: 'Z domovního zásobníku – důlní plyn',
    storage_tank_other: 'Z domovního zásobníku – ostatní',
    gas_in_building: 'Plyn v domě',
  },
  RuianSewerConnection: {
    public_network: 'Přípojka na kanalizační síť',
    home_treatment: 'Domácí čistička odpadních vod',
    cesspoll: 'Žumpa/jímka',
    no_canalization: 'Bez kanalizace a jímky',
  },
  RuianUseOfConstruction: {
    industrial: 'Průmyslový objekt',
    farmstead: 'Zemědělská usedlost',
    for_living: 'Objekt k bydlení',
    forestry: 'Objekt lesního hospodářství',
    object_civic_amenity: 'Objekt občanské vybavenosti',
    apartment_building: 'Bytový dům',
    family_house: 'Rodinný dům',
    family_recreation: 'Stavba pro rodinnou rekreaci',
    for_gathering: 'Stavba pro shromažďování většího počtu osob',
    trade: 'Stavba pro obchod',
    accommodation: 'Stavba ubytovacího zařízení',
    production_and_storage: 'Stavba pro výrobu a skladování',
    agricultural_building: 'Zemědělská stavba',
    administrative: 'Stavba pro administrativu',
    construction_civic_amenity: 'Stavba občanského vybavení',
    technical: 'Stavba technického vybavení',
    transportation: 'Stavba pro dopravu',
    garage: 'Garáž',
    other: 'Jiná stavba',
    multipurpose: 'Víceúčelová stavba',
    greenhouse: 'Skleník',
    dam: 'Přehrada',
    dam_on_river: 'Hráz přehrazující vodní tok nebo údolí',
    protective_dam: 'Hráz k ochraně nemovitostí před zaplavením',
    dam_with_artificial_lake: 'Hráz ohrazující umělou vodní nádrž',
    weir: 'Jez',
    boat_infrastructure: 'Stavba k plavebním účelům',
    hydroelectric_dam: 'Stavba k využití vodní energie',
    sludge_pond: 'Stavba odkaliště',
    in_construction: 'Rozestavěné jednotky',
  },
};

export default {
  AdminRegistration,
  Announcements,
  App,
  Building,
  Card,
  Date,
  Deadlines,
  DateField,
  Editor,
  Enums,
  Feed,
  FileField,
  Files,
  FormValidation,
  Header,
  Invitation,
  Issues,
  Welcome,
  Login,
  MobileAppBanner,
  NotificationUnsubscribe,
  OtherServices,
  PasswordField,
  PasswordReset,
  Playground,
  Poll,
  Profile,
  ReadReceipt,
  Registration,
  SelectField,
  Sidebar,
  Subscription,
  Units,
  Registry,
};
